(function($) {
    $.extend({
        displayLoadingIndicator : function(text, domElement, transition) {
            $.displayAnimatedLogo(text, domElement);
        },
        removeLoadingIndicator : function() {
            $.removeAnimatedLogo();
            $.removeProgressBar();
        }
    });
})(jQuery);